import { jsx as e, Fragment as r } from "react/jsx-runtime";
import m from "react";
import { $ as c } from "./index-D_37ItTm.js";
const l = "_skeleton_11ljz_1", f = {
  skeleton: l
};
function u({
  loading: o = !0,
  width: s,
  height: a,
  children: t
}) {
  if (!o)
    return /* @__PURE__ */ e(r, { children: t });
  const n = m.isValidElement(t) ? c : "span";
  return /* @__PURE__ */ e(
    n,
    {
      style: { width: s, height: a },
      className: f.skeleton,
      "data-empty": t === void 0,
      children: t
    }
  );
}
export {
  u as S
};
